// extracted by mini-css-extract-plugin
export var button = "_f4-2";
export var card = "_f4-0";
export var closeButtonContainer = "_f4-3";
export var iconContainer = "_f4-1";